<template>
  <div class="suspage">
    <div class="susicon" v-show="getRegState(1)">
      <img src="../../assets/images/sus.png" alt class="icon">
      <span>挂号成功！</span>
    </div>
    <div class="susicon" v-show="getRegState(0)">
      <img src="../../assets/images/查询.png" alt class="icon">
      <span>结果确认中...</span>
    </div>
    <div class="susicon" v-show="getRegState(2)">
      <img src="../../assets/images/失败.png" alt class="icon">
      <span>挂号失败！</span>
    </div>
    <div class="susflex">
      <div class="surlist">
        <span class="listline"></span>
        <p>
          <span class="title">就诊人信息</span>
        </p>
        <p>
          <span>姓名：</span>
          <span>{{regInfo.PatName}}</span>
        </p>
        <p>
          <span>档案号：</span>
          <span>{{regInfo.PatNo}}</span>
        </p>
      </div>
      <div class="surlist">
        <span class="listline"></span>
        <p>
          <span class="title">挂号信息</span>
        </p>
        <p>
          <span>就诊科室：</span>
          <span>{{regInfo.DptName}}</span>
        </p>
        <p>
          <span>就诊医生：</span>
          <span>{{regInfo.DctName}}</span>
        </p>
        <p>
          <span>就诊日期：</span>
          <span>{{regInfo.VisitDate}}</span>
        </p>
        <p>
          <span>预估就诊时间：</span>
          <span>{{regInfo.EstimatedTime}}</span>
        </p>
        <p>
          <span>挂号费用：</span>
          <span>¥{{regInfo.RegAmount}}</span>
        </p>
        <p>
          <span>科室区域：</span>
          <span>{{regInfo.Address}}</span>
        </p>
      </div>
    </div>
    <div class="surebnt">
      <span :class="getRegClass(2)" @click="bankhome" id="btnHome">返回首页</span>
      <span @click="cancel" v-show="!getRegState(2)">取消预约</span>
    </div>
  </div>
</template>
<script>
  import {
    GetRegSuccess,
    HISBackNumber,
    QueryOrderState
  } from "@/services/getData.js";
  import weui from "weui.js";
  export default {
    name: "register-sus",
    data() {
      return {
        outOrder: this.$route.query.outOrder,
        regInfo: [],
        $dialog: [],
        returnState: 0,
        regID: ""
      };
    },
    created: function () {
      this.getRegSuccess();
    },
    destroyed: function () {
      if (Object.prototype.toString.call(this.$dialog) !== "[object Function]") {
        this.$dialog.hide();
      }
    },
    methods: {
      bankhome() {
        //返回首页
        this.$router.push({ path: "/", params: { userId: 123 } });
      },
      cancel() {
        //取消预约
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        var _that = this;
        _that.$dialog = weui.dialog({
          content: "是否确定取消预约",
          className: "custom-classname",
          buttons: [
            {
              label: "否",
              type: "default",
              onClick: function () {
                loading.hide();
              }
            },
            {
              label: "是",
              type: "primary",
              onClick: function () {
                _that.$dialog.hide(function () {
                  HISBackNumber(_that.regID).then(response => {
                    loading.hide();
                    if (response.data.Result) {
                      _that.$dialog = weui.dialog({
                        title: "提示",
                        content: "您已退号成功，费用会在3个工作日内原路返还",
                        buttons: [
                          {
                            label: "确定",
                            type: "default",
                            onClick: function () {
                              _that.$router.push({
                                name: "PersonalRecorddeteil",
                                query: { regID: _that.regID }
                              });
                            }
                          }
                        ]
                      });
                    } else {
                      _that.$dialog = weui.dialog({
                        title: "提示",
                        content: response.data.Content
                      });
                    }
                  });
                });
              }
            }
          ]
        });
      },
      getRegSuccess() {
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        if (this.$route.query.regID) {
          this.regID = this.$route.query.regID;
          GetRegSuccess(this.regID).then(response => {
            loading.hide();
            if (response.data) {
              this.returnState = 1;
              this.regInfo = response.data;
            }
          });
        }
        else {
          QueryOrderState(this.outOrder, 10)
            .then(response => {
              loading.hide();
              this.returnState = 1;
              this.regID = response.data.Extend;
              GetRegSuccess(response.data.Extend).then(response => {
                loading.hide();
                if (response.data) {
                  this.regInfo = response.data;
                }
              });
            })
            .catch(err => {
              loading.hide();
              this.returnState = 2;
            });
        }
      },
      getRegState(state) {
        if (state == this.returnState) {
          return true;
        } else {
          return false;
        }
      },
      getRegClass(state) {
        if (state != this.returnState) {
          return "mr20";
        } else {
          return "mr30";
        }
      }
    }
  };
</script>
<style>
  .suspage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

    .suspage .susflex {
      flex: 1;
      overflow: auto;
    }

    .suspage .susicon {
      width: 100%;
      height: 2.2rem;
      background: white;
      text-align: center;
      box-sizing: border-box;
      padding-top: 0.32rem;
      font-size: 0.3rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 0.2rem;
    }

      .suspage .susicon .icon {
        width: 1.02rem;
        height: 1.07rem;
        margin: 0 auto;
        margin-bottom: 0.1rem;
      }

    .suspage .surebnt {
      height: 0.8rem;
      margin: 0.2rem;
      font-family: "MicrosoftYaHei";
      font-size: 0.26rem;
      color: #fffefe;
      text-align: center;
      line-height: 0.8rem;
      display: flex;
      margin-top: 0.3rem;
    }

      .suspage .surebnt > span {
        width: 50%;
        display: inline-block;
        /* margin-right: 0.2rem; */
        background-color: #1592e4;
      }

      .suspage .surebnt .mr20 {
        margin-right: 0.2rem;
      }

      .suspage .surebnt .mr30 {
        width: 100%;
      }

    .suspage .surlist {
      padding: 0 0.2rem;
      box-sizing: border-box;
      width: 100%;
      height: auto;
      background-color: white;
      position: relative;
      margin-bottom: 0.2rem;
    }

      .suspage .surlist > p {
        width: 100%;
        border-bottom: 0.01rem solid #dddddd;
        height: 0.79rem;
        line-height: 0.8rem;
        font-size: 0.26rem;
        font-family: MicrosoftYaHei;
        font-weight: 400;
      }

        .suspage .surlist > p > span:first {
          color: #333333;
          text-align: left;
        }

        .suspage .surlist > p > span:last-child {
          color: #999999;
          text-align: right;
          float: right;
        }

        .suspage .surlist > p > .title {
          color: #1592e4 !important;
          float: left !important;
        }

      .suspage .surlist .listline {
        display: block;
        position: absolute;
        width: 0.08rem;
        height: 0.8rem;
        background: rgba(21, 146, 228, 1);
        top: 0;
        left: 0;
      }
</style>




// WEBPACK FOOTER //
// src/components/register/register-sus.vue